<template>
  <div>
    <!-- 多条件筛选区域 -->
    <div
      class="filter-section"
      style="display: flex; flex-wrap: wrap; margin: 0 -7.5px; margin-top: 20px"
    >
      <el-date-picker
        v-model="searchStartDate"
        type="date"
        placeholder="选择日期"
      >
      </el-date-picker>

      <span style="margin-left: 20px; margin-right: 20px">~</span>

      <el-date-picker
        v-model="searchStopDate"
        type="date"
        placeholder="选择日期"
      >
      </el-date-picker>

      <el-select
        v-model="searchCustomerId"
        filterable
        clearable
        placeholder="购买客户"
        style="margin-left: 20px"
      >
        <el-option
          v-for="item in customerList"
          :key="item.objectId"
          :label="item.name"
          :value="item.objectId"
        >
        </el-option>
      </el-select>

      <el-button type="primary" @click="handleSearch" style="margin-left: 20px">
        数据统计
      </el-button>
    </div>

    <!-- 数据统计 -->
    <el-row :gutter="20" class="filter-section" type="flex">
      <el-col :span="3">
        <div>
          <el-statistic
            group-separator=","
            :precision="2"
            :value="orderTotalAmount"
            title="订单总金额"
          ></el-statistic>
        </div>
      </el-col>

      <el-col :span="3">
        <div>
          <el-statistic
            group-separator=","
            :precision="2"
            :value="orderTotalProfit"
            title="订单总利润"
          ></el-statistic>
        </div>
      </el-col>

      <el-col :span="3">
        <div>
          <el-statistic
            group-separator=","
            :precision="2"
            :value="returnOrderTotalAmount"
            title="退单总金额"
          ></el-statistic>
        </div>
      </el-col>

      <el-col :span="3">
        <div>
          <el-statistic
            group-separator=","
            :precision="2"
            :value="returnOrderTotalProfit"
            title="退单总利润"
          ></el-statistic>
        </div>
      </el-col>

      <el-col :span="3">
        <div>
          <el-statistic
            group-separator=","
            :precision="2"
            :value="totalAmount"
            title="总销售额"
          ></el-statistic>
        </div>
      </el-col>

      <el-col :span="3">
        <div>
          <el-statistic
            group-separator=","
            :precision="2"
            :value="profit"
            title="总利润"
          ></el-statistic>
        </div>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-table
      :data="tableData"
      border
      style="width: 100%; margin-top: 20px"
      v-loading="loading"
    >
      <!-- 类型字段转换列 -->
      <el-table-column
        prop="customerId"
        label="购买客户"
        width="180"
        :formatter="formatCustomerText"
      ></el-table-column>

      <el-table-column
        prop="orderAmount"
        label="订单金额"
        width="180"
      ></el-table-column>

      <el-table-column
        prop="orderAdditionalAmount"
        label="订单附加金额"
        width="180"
      ></el-table-column>

      <el-table-column
        prop="orderTotalAmount"
        label="订单总金额"
        width="180"
      ></el-table-column>

      <el-table-column
        prop="returnOrderAmount"
        label="退单金额"
        width="180"
      ></el-table-column>

      <el-table-column
        prop="returnOrderAdditionalAmount"
        label="退单附加金额"
        width="180"
      ></el-table-column>

      <el-table-column
        prop="returnOrderTotalAmount"
        label="退单总金额"
        width="180"
      ></el-table-column>

      <el-table-column
        prop="totalAmount"
        label="总销售额"
        width="200"
      ></el-table-column>

      <el-table-column
        prop="profit"
        label="总利润"
        width="200"
      ></el-table-column>
    </el-table>

    <!-- 销售趋势图表 -->
    <el-card class="chart-card" v-if="Object.keys(chartData).length > 0">
      <div slot="header" class="chart-title">
        <span>销售趋势</span>
      </div>

      <div>
        <el-card>
          <!-- 折线图组件 -->
          <line-chart
            ref="lineChartRef"
            :api-data="chartData"
            :y-axis-name="'金额'"
            :loading="loading"
          />
        </el-card>
      </div>
    </el-card>
  </div>
</template>

<script>
import LineChart from "./LineChart.vue";
import axios from "axios";

export default {
  components: {
    LineChart,
  },

  data() {
    return {
      tableData: [], // 表格数据
      chartData: {},
      orderTotalAmount: 0,
      orderTotalProfit: 0,
      returnOrderTotalAmount: 0,
      returnOrderTotalProfit: 0,
      totalAmount: 0,
      profit: 0,

      searchStartDate: Date.now(),
      searchStopDate: Date.now(),
      searchCustomerId: "",
      loading: false, // 加载状态
    };
  },

  created() {
    this.fetchCustomerData();
    this.fetchData();
  },

  methods: {
    // 获取表格数据
    async fetchData() {
      try {
        this.loading = true;
        const params = {
          startDate: new Date(this.searchStartDate).toLocaleDateString("en-CA"),
          stopDate: new Date(this.searchStopDate).toLocaleDateString("en-CA"),
          customerId: this.searchCustomerId,
        };
        const response = await axios.post(
          "/api/DataStatistics/getCustomerDataStatisticsInfo",
          params
        );

        this.tableData = response.data.result.dataOverviews;
        this.totalAmount = response.data.result.totalAmount;
        this.profit = response.data.result.profit;
        this.orderTotalAmount = response.data.result.orderTotalAmount;
        this.orderTotalProfit = response.data.result.orderTotalProfit;
        this.returnOrderTotalAmount = response.data.result.returnOrderTotalAmount;
        this.returnOrderTotalProfit = response.data.result.returnOrderTotalProfit;
        this.chartData = response.data.result.dailyDataStatistics;
      } finally {
        this.loading = false;
      }
    },

    // 客户数据加载
    async fetchCustomerData() {
      try {
        const response = await axios.get("/api/Customer/getAllCustomer");

        this.customerList = response.data.result;

        this.customerMap = new Map();
        for (var item of response.data.result) {
          this.customerMap.set(item.objectId, item.name);
        }
      } catch (error) {
        console.error("数据加载失败:", error);
      }
    },

    // 格式化客户字段
    formatCustomerText(row) {
      return this.customerMap.get(row.customerId) || "未知客户";
    },

    // 搜索
    handleSearch() {
      this.fetchData();
    },
  },
};
</script>

<style scoped>
.filter-section {
  margin-bottom: 20px;
}

.el-col {
  margin-bottom: 10px;
}

.error-alert {
  margin-bottom: 20px;
}

.part-item-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #eee;
  border-radius: 4px;
}

.part-item-header >>> .el-form-item {
  margin-bottom: 0;
  margin-right: 15px;
}

.container {
  display: flex;
  width: 900px;
  flex-wrap: wrap;
}

.part-item {
  display: flex;
  width: 400px;
  align-items: center;
}

.part-item >>> .el-form-item {
  margin-bottom: 0;
  margin-right: 15px;
}

.action-bar {
  text-align: center;
  margin-top: 20px;
}

.data-overview {
  margin-bottom: 20px;
}

.card-content {
  display: flex;
  align-items: center;
  padding: 20px;
}

.card-icon {
  font-size: 40px;
  margin-right: 15px;
  color: #409eff;
}

.card-title {
  color: #909399;
  margin-bottom: 5px;
}

.card-value {
  font-size: 24px;
  font-weight: bold;
}

.chart-card {
  margin-bottom: 20px;
}

.chart-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.el-statistic {
  text-align: center;
}
</style>